/**
 * sc-48743: aliquote IVA ammesse e prezzo di riga al cambio di aliquota.
 */

// Le stesse del select «IVA» del form e della validazione del modello Item.
export const ALIQUOTE_IVA = [22, 10, 4];

const cent = (n) => Number(n.toFixed(2));

/**
 * Prezzo unitario ivato con un'altra aliquota, a parità di imponibile.
 * Passa dal listino al 22% come unitPriceIvato nell'API
 * (src/utils/calcPriceIvato.js), così web e server arrotondano allo stesso modo.
 */
export function prezzoConIva(prezzo, ivaAttuale, ivaNuova) {
  const p = Number(prezzo);
  if (!Number.isFinite(p)) return 0;
  const da = Number(ivaAttuale ?? 22);
  const a = Number(ivaNuova);
  if (da === a) return p;
  const listino22 = da === 22 ? p : (p / (1 + da / 100)) * 1.22;
  if (a === 22) return cent(listino22);
  return cent((listino22 / 1.22) * (1 + a / 100));
}
